import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { FileViewOnlyCard } from "@components/FileViewOnlyCard";

import { UploadFileType } from "@type/HRM/upload-file";
import { SetStateAction } from "react";
import { IconTrash01 } from "@pentabd/icons";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  setIsConfirmationModalOpen: (value: SetStateAction<boolean>) => void,
  setItemID: (value: SetStateAction<number | undefined>) => void,
) => {
  return [
    {
      id: 1,
      key: "year",
      name: t("EMPLOYEE.APR_INFO.FORM.APR_TABLE_INFO.COLUMN_1"),
      render: (year: string) => (
        <Text size="sm" weight="medium" color="info">
          {year}
        </Text>
      ),
    },
    {
      id: 2,
      key: "mark",
      name: t("EMPLOYEE.APR_INFO.FORM.APR_TABLE_INFO.COLUMN_2"),
      render: (mark: string) => (
        <Text size="sm" color="subtitle1">
          {mark}
        </Text>
      ),
    },
    {
      id: 3,
      key: "aprDocuments",
      name: t("EMPLOYEE.APR_INFO.FORM.APR_TABLE_INFO.COLUMN_3"),
      render: (aprDocuments: UploadFileType[]) => (
        // use largeCol prop only if there are so many columns in the table and the file rows breaks
        <FileViewOnlyCard data={aprDocuments} largeCol />
      ),
    },
    {
      id: 4,
      key: "kpiDocuments",
      name: t("EMPLOYEE.APR_INFO.FORM.APR_TABLE_INFO.COLUMN_4"),
      render: (kpiDocuments: UploadFileType[]) => (
        // use largeCol prop only if there are so many columns in the table and the file rows breaks
        <FileViewOnlyCard data={kpiDocuments} largeCol />
      ),
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: number) => {
        return (
          <div
            onClick={() => {
              setIsConfirmationModalOpen(true);
              setItemID(id);
            }}
            className="cursor-pointer"
          >
            <IconTrash01 size="20" fill="danger" />
          </div>
        );
      },
    },
  ];
};
